import styled from 'styled-components';
import { renderStyledElementStyles } from '../../../../helpers';

export const StyledOptionDisplayWrapper = styled.div``;

export const StyledCardMenuPosition = styled.div`
  top: 24px;
  position: absolute;
  z-index: 99999;
`;

export const StyledOptionDisplayFilter = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  text-align: left;
  margin-bottom: 16px;
  flex-wrap: wrap;
`;

export const StyledCardFilterBy = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const StyledCardFilterItem = styled.div`
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
`;

export const StyledOptionDisplayFilterItem = styled.div`
  position: relative;
`;

export const StyledOptionDisplayCardsList = styled.ul``;

export const StyledOptionDisplayCard = styled.li`
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }

  ${({ theme }) =>
    renderStyledElementStyles(theme, theme.module.dStyles.elements.card)}
  ${({ theme }) =>
    renderStyledElementStyles(theme, theme.module.vStyles.elements.card)}
`;

export const StyledOptionDisplayCardSection = styled.div`
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
`;
